export const validateForm = (event: any, state: any): any => {
  if (state.hasOwnProperty('username') && state.username === '') {
    return { blankfield: true };
  }
  if (state.hasOwnProperty('password') && state.password === '') {
    return { blankfield: true };
  }
  return;
};
